import React from 'react';
import Header from '../Header';
import Form from '../Form';
import './Top.scss';

const Top = (props) => (
    <section className="ghg-section ghg-top">
        <Header/>
        <Form/>
    </section>
);

export default Top;


/** WEBPACK FOOTER **
 ** ./src/components/Top/Top.js
 **/